var render = function render(){
  var _vm$projectData, _vm$projectData$custo, _vm$projectData2, _vm$projectData3, _vm$projectData4, _vm$projectData5, _vm$projectData5$dist, _vm$projectData6, _vm$projectData7, _vm$projectData8, _vm$projectData9, _vm$projectData10, _vm$projectData11, _vm$projectData12, _vm$projectData13, _vm$projectData14, _vm$projectData$cargo, _vm$projectData15, _vm$projectData15$car, _vm$projectData16, _vm$projectData16$con, _vm$projectData17, _vm$projectData17$con, _vm$projectData$total, _vm$projectData18, _vm$projectData18$tot, _vm$projectData$unit, _vm$projectData19, _vm$projectData$terms, _vm$projectData20, _vm$projectData20$ter, _vm$projectData$remar, _vm$projectData21, _vm$projectData22, _vm$projectData22$pro, _vm$projectData23, _vm$listTrips, _vm$listTrips2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [!_vm.project_data_loading ? _c('b-row', [_c('b-col', {
    staticClass: "p-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "lg": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": '12'
    }
  }, [_c('div', {
    staticClass: "section-title mb-4"
  }, [_c('h5', [_vm._v("Project Info")])]), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Company Name ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(" " + _vm._s((_vm$projectData = _vm.projectData) === null || _vm$projectData === void 0 ? void 0 : (_vm$projectData$custo = _vm$projectData.customer) === null || _vm$projectData$custo === void 0 ? void 0 : _vm$projectData$custo.account_name) + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Port of Loading ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "d-flex flex-column"
  }, _vm._l((_vm$projectData2 = _vm.projectData) === null || _vm$projectData2 === void 0 ? void 0 : _vm$projectData2.pol, function (polObj, polIndex) {
    var _polObj$value;
    return _c('strong', {
      key: polIndex
    }, [_vm._v(" " + _vm._s((_polObj$value = polObj === null || polObj === void 0 ? void 0 : polObj.value) !== null && _polObj$value !== void 0 ? _polObj$value : '-') + " ")]);
  }), 0)])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Fleet Ownership ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('b-badge', {
    staticClass: "border border-dark text-dark text-uppercase font-weight-bold",
    attrs: {
      "variant": "none"
    }
  }, [_vm._v(" " + _vm._s(((_vm$projectData3 = _vm.projectData) === null || _vm$projectData3 === void 0 ? void 0 : _vm$projectData3.fleet_ownership) === 'own-ship' ? 'Own Ship' : 'Chartered') + " ")])], 1)]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Port of Discharging ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "d-flex flex-column"
  }, _vm._l((_vm$projectData4 = _vm.projectData) === null || _vm$projectData4 === void 0 ? void 0 : _vm$projectData4.pod, function (podObj, podIndex) {
    var _podObj$value;
    return _c('strong', {
      key: podIndex
    }, [_vm._v(" " + _vm._s((_podObj$value = podObj === null || podObj === void 0 ? void 0 : podObj.value) !== null && _podObj$value !== void 0 ? _podObj$value : '-') + " ")]);
  }), 0)])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Fleet Type ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "d-flex flex-wrap"
  }, [_c('b-badge', {
    staticClass: "border border-dark text-dark text-uppercase mr-1 font-weight-bold",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "variant": "none"
    }
  }, [_vm._v(" Tugboat ")])], 1)])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Distance ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(" " + _vm._s((_vm$projectData5 = _vm.projectData) === null || _vm$projectData5 === void 0 ? void 0 : (_vm$projectData5$dist = _vm$projectData5.distance) === null || _vm$projectData5$dist === void 0 ? void 0 : _vm$projectData5$dist.toLocaleString()) + " NM ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Period ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(" " + _vm._s((_vm$projectData6 = _vm.projectData) !== null && _vm$projectData6 !== void 0 && _vm$projectData6.periode_start ? _vm.$moment((_vm$projectData7 = _vm.projectData) === null || _vm$projectData7 === void 0 ? void 0 : _vm$projectData7.periode_start).format('DD/MM/YYYY') : '-') + " - " + _vm._s((_vm$projectData8 = _vm.projectData) !== null && _vm$projectData8 !== void 0 && _vm$projectData8.periode_end ? _vm.$moment((_vm$projectData9 = _vm.projectData) === null || _vm$projectData9 === void 0 ? void 0 : _vm$projectData9.periode_end).format('DD/MM/YYYY') : '-') + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Laycan ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(" " + _vm._s((_vm$projectData10 = _vm.projectData) !== null && _vm$projectData10 !== void 0 && _vm$projectData10.laycan_start ? _vm.$moment((_vm$projectData11 = _vm.projectData) === null || _vm$projectData11 === void 0 ? void 0 : _vm$projectData11.laycan_start).format('DD MMMM YYYY') : '-') + " - " + _vm._s((_vm$projectData12 = _vm.projectData) !== null && _vm$projectData12 !== void 0 && _vm$projectData12.laycan_end ? _vm.$moment((_vm$projectData13 = _vm.projectData) === null || _vm$projectData13 === void 0 ? void 0 : _vm$projectData13.laycan_end).format('DD MMMM YYYY') : '-') + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Shipment Plan Number ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(_vm._s((_vm$projectData14 = _vm.projectData) === null || _vm$projectData14 === void 0 ? void 0 : _vm$projectData14.shipment_plan_number))])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Cargo Type ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(" " + _vm._s((_vm$projectData$cargo = (_vm$projectData15 = _vm.projectData) === null || _vm$projectData15 === void 0 ? void 0 : (_vm$projectData15$car = _vm$projectData15.cargo_type) === null || _vm$projectData15$car === void 0 ? void 0 : _vm$projectData15$car.name) !== null && _vm$projectData$cargo !== void 0 ? _vm$projectData$cargo : 'COAL') + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Contract Type ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('div', [_c('strong', [_vm._v(" " + _vm._s((_vm$projectData16 = _vm.projectData) === null || _vm$projectData16 === void 0 ? void 0 : (_vm$projectData16$con = _vm$projectData16.contract_type) === null || _vm$projectData16$con === void 0 ? void 0 : _vm$projectData16$con.name) + " ")]), _c('br'), _c('b-alert', {
    staticClass: "d-flex align-items-center p-2",
    attrs: {
      "show": ((_vm$projectData17 = _vm.projectData) === null || _vm$projectData17 === void 0 ? void 0 : (_vm$projectData17$con = _vm$projectData17.contract_type) === null || _vm$projectData17$con === void 0 ? void 0 : _vm$projectData17$con.name) === 'Spot Freight Charter'
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-primary"
  }), _c('small', {
    staticClass: "text-muted ml-1"
  }, [_vm._v(" This type using SPAL ")])])], 1)])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Total Plan QTY ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(" " + _vm._s((_vm$projectData$total = (_vm$projectData18 = _vm.projectData) === null || _vm$projectData18 === void 0 ? void 0 : (_vm$projectData18$tot = _vm$projectData18.total_quantity) === null || _vm$projectData18$tot === void 0 ? void 0 : _vm$projectData18$tot.toLocaleString()) !== null && _vm$projectData$total !== void 0 ? _vm$projectData$total : '10.000') + " " + _vm._s((_vm$projectData$unit = (_vm$projectData19 = _vm.projectData) === null || _vm$projectData19 === void 0 ? void 0 : _vm$projectData19.unit) !== null && _vm$projectData$unit !== void 0 ? _vm$projectData$unit : 'MT') + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Term ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(" " + _vm._s((_vm$projectData$terms = (_vm$projectData20 = _vm.projectData) === null || _vm$projectData20 === void 0 ? void 0 : (_vm$projectData20$ter = _vm$projectData20.terms) === null || _vm$projectData20$ter === void 0 ? void 0 : _vm$projectData20$ter.name) !== null && _vm$projectData$terms !== void 0 ? _vm$projectData$terms : '7 D (Payment 7 Days After Invoice Send)') + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-muted mr-2",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(" Remarks ")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(":")]), _c('strong', [_vm._v(" " + _vm._s((_vm$projectData$remar = (_vm$projectData21 = _vm.projectData) === null || _vm$projectData21 === void 0 ? void 0 : _vm$projectData21.remarks) !== null && _vm$projectData$remar !== void 0 ? _vm$projectData$remar : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.') + " ")])])])], 1)], 1)], 1)], 1), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "section-title mb-4"
  }, [_c('h5', [_vm._v("Detail Shipment Plan")])]), _c('div', {
    staticClass: "d-flex overflow-auto",
    staticStyle: {
      "max-height": "500px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', {
    staticClass: "sticky-header text-black"
  }, [_c('th', {
    staticClass: "text-center text-black"
  }, [_vm._v("#")]), _c('th', {
    staticClass: "text-truncate text-black"
  }, [_vm._v("Number Detail Plan")]), _c('th', {
    staticClass: "text-truncate text-black"
  }, [_vm._v("Fleet")]), _c('th', {
    staticClass: "text-truncate text-black"
  }, [_vm._v("Cargo Type")]), _c('th', {
    staticClass: "text-truncate text-black"
  }, [_vm._v("Plan Quantity")]), _c('th', {
    staticClass: "text-truncate text-black"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "text-truncate text-black text-center"
  }, [_vm._v("Description")]), _c('th', {
    staticClass: "text-truncate text-black text-center"
  }, [_vm._v("Remarks")])])]), ((_vm$projectData22 = _vm.projectData) === null || _vm$projectData22 === void 0 ? void 0 : (_vm$projectData22$pro = _vm$projectData22.project_contract_plan) === null || _vm$projectData22$pro === void 0 ? void 0 : _vm$projectData22$pro.length) > 0 ? _c('tbody', _vm._l((_vm$projectData23 = _vm.projectData) === null || _vm$projectData23 === void 0 ? void 0 : _vm$projectData23.project_contract_plan, function (val, index) {
    var _val$cargo_type, _val$plan_quantity, _vm$projectData24;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('b-form-checkbox', {
      attrs: {
        "name": "checked",
        "disabled": val.disabled
      },
      on: {
        "change": function change($event) {
          return _vm.onCheckedPlan(index);
        }
      },
      model: {
        value: val.checked,
        callback: function callback($$v) {
          _vm.$set(val, "checked", $$v);
        },
        expression: "val.checked"
      }
    })], 1), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : val.shipment_plan_detail_number) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "d-flex w-100"
    }, _vm._l(val === null || val === void 0 ? void 0 : val.fleets, function (obj, objIndex) {
      return _c('b-badge', {
        key: objIndex,
        staticClass: "border border-primary text-primary text-uppercase mr-1",
        attrs: {
          "variant": "none"
        }
      }, [_vm._v(" " + _vm._s(_vm.showVehicleName(obj.vehicle_id)) + " ")]);
    }), 1)]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : (_val$cargo_type = val.cargo_type) === null || _val$cargo_type === void 0 ? void 0 : _val$cargo_type.name))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : (_val$plan_quantity = val.plan_quantity) === null || _val$plan_quantity === void 0 ? void 0 : _val$plan_quantity.toLocaleString()) + " " + _vm._s((_vm$projectData24 = _vm.projectData) === null || _vm$projectData24 === void 0 ? void 0 : _vm$projectData24.unit) + " ")]), _c('td', {
      staticClass: "text-truncate text-capitalize"
    }, [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : val.status) + " ")]), _c('td', {
      staticClass: "text-truncate text-center",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_c('b-button', {
      attrs: {
        "variant": "primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.showDescriptionModal(val === null || val === void 0 ? void 0 : val.description);
        }
      }
    }, [_vm._v(" Description ")])], 1), _c('td', {
      staticClass: "text-truncate text-center",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_c('b-button', {
      attrs: {
        "variant": "primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.showRemarksModal(val === null || val === void 0 ? void 0 : val.remarks);
        }
      }
    }, [_vm._v(" Remark ")])], 1)]);
  }), 0) : _vm._e()])])]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "section-title mb-4"
  }, [_c('h5', [_vm._v("Fleet Operational")])]), _c('b-row', [_c('b-col', {
    staticClass: "d-flex mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('date-picker', {
    staticClass: "mr-2",
    style: {
      width: '240px'
    },
    attrs: {
      "type": "date",
      "range": "",
      "placeholder": "Select date range"
    },
    model: {
      value: _vm.dateRange,
      callback: function callback($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c('v-select', {
    style: {
      width: '200px'
    },
    attrs: {
      "label": "text",
      "name": "vehicle_id",
      "options": _vm.optionsFleets,
      "reduce": function reduce(optionsFleets) {
        return optionsFleets.value;
      },
      "placeholder": "Select Fleet"
    },
    model: {
      value: _vm.params.vehicle_id,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "vehicle_id", $$v);
      },
      expression: "params.vehicle_id"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_vm._l(_vm.fixedColumns, function (col, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center text-black text-truncate align-middle sticky-column",
      class: {
        'sticky-column-1': index === 0,
        'sticky-column-2': index === 1
      },
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(" " + _vm._s(col.title) + " ")]);
  }), _c('th', {
    staticClass: "bg-primary-custom text-center text-white",
    attrs: {
      "colspan": _vm.portOfLoadingColumns.length
    }
  }, [_vm._v(" Port of Loading ")]), _c('th', {
    staticClass: "bg-warning-custom text-center text-white",
    attrs: {
      "colspan": _vm.portOfDischargeColumns.length
    }
  }, [_vm._v(" Port of Discharge ")])], 2), _c('tr', [_vm._l(_vm.portOfLoadingColumns, function (col, index) {
    return _c('th', {
      key: "pol-".concat(index),
      staticClass: "bg-primary-custom text-truncate text-white"
    }, [_vm._v(" " + _vm._s(col) + " ")]);
  }), _vm._l(_vm.portOfDischargeColumns, function (col, index) {
    return _c('th', {
      key: "pod-".concat(index),
      staticClass: "bg-warning-custom text-truncate text-white"
    }, [_vm._v(" " + _vm._s(col) + " ")]);
  })], 2)]), ((_vm$listTrips = _vm.listTrips) === null || _vm$listTrips === void 0 ? void 0 : _vm$listTrips.length) > 0 ? _c('tbody', _vm._l(_vm.listTrips, function (val, index) {
    var _val$tripRecord, _val$tripRecord2, _Number, _val$tripRecord3, _Number2, _val$tripRecord4, _val$tripRecord5, _val$tripRecord6, _val$tripRecord6$port, _val$tripRecord7, _val$tripRecord8, _val$tripRecord9, _val$tripRecord10, _val$tripRecord11, _val$tripRecord12, _val$tripRecord13, _val$tripRecord14, _val$tripRecord15, _val$tripRecord16, _val$tripRecord17, _val$tripRecord18, _val$tripRecord19, _val$tripRecord20, _Number$toLocaleStrin, _Number3, _val$tripRecord21, _val$tripRecord22, _val$tripRecord23, _val$tripRecord24, _val$tripRecord25, _val$tripRecord26, _val$tripRecord27, _val$tripRecord28, _val$tripRecord29, _val$tripRecord30, _val$tripRecord31, _val$tripRecord32, _val$tripRecord33, _val$tripRecord34, _val$tripRecord34$por, _val$tripRecord35, _val$tripRecord36, _val$tripRecord37, _val$tripRecord38, _val$tripRecord39, _val$tripRecord40, _val$tripRecord41, _val$tripRecord42, _val$tripRecord43, _val$tripRecord44, _val$tripRecord45, _val$tripRecord46, _val$tripRecord47, _val$tripRecord48, _Number$toLocaleStrin2, _val$tripRecord49, _val$tripRecord50, _val$tripRecord51, _val$tripRecord52, _val$tripRecord53, _val$tripRecord54, _val$tripRecord55, _val$tripRecord56;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center sticky-column sticky-column-1 bg-white"
    }, [_c('b-form-checkbox', {
      staticClass: "d-flex justify-content-center",
      attrs: {
        "name": "checked",
        "disabled": val.disabled
      },
      on: {
        "change": function change($event) {
          return _vm.onCheckedTrips(index);
        }
      },
      model: {
        value: val.checked,
        callback: function callback($$v) {
          _vm.$set(val, "checked", $$v);
        },
        expression: "val.checked"
      }
    })], 1), _c('td', {
      staticClass: "text-truncate sticky-column sticky-column-2 bg-white"
    }, [_c('div', {
      staticClass: "d-flex w-100"
    }, _vm._l(val === null || val === void 0 ? void 0 : val.vehicle, function (obj, objIndex) {
      return _c('b-badge', {
        key: objIndex,
        staticClass: "border border-primary text-primary text-uppercase mr-1",
        attrs: {
          "variant": "none"
        }
      }, [_vm._v(" " + _vm._s(obj === null || obj === void 0 ? void 0 : obj.name) + " ")]);
    }), 1)]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : (_val$tripRecord = val.tripRecord) === null || _val$tripRecord === void 0 ? void 0 : _val$tripRecord.status) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : (_val$tripRecord2 = val.tripRecord) === null || _val$tripRecord2 === void 0 ? void 0 : _val$tripRecord2.cargoType) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s((_Number = Number(val === null || val === void 0 ? void 0 : (_val$tripRecord3 = val.tripRecord) === null || _val$tripRecord3 === void 0 ? void 0 : _val$tripRecord3.cargoUnloading)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString()) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s((_Number2 = Number(val === null || val === void 0 ? void 0 : (_val$tripRecord4 = val.tripRecord) === null || _val$tripRecord4 === void 0 ? void 0 : _val$tripRecord4.cargoLoading)) === null || _Number2 === void 0 ? void 0 : _Number2.toLocaleString()) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s((val === null || val === void 0 ? void 0 : (_val$tripRecord5 = val.tripRecord) === null || _val$tripRecord5 === void 0 ? void 0 : _val$tripRecord5.agentPol) || '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s((val === null || val === void 0 ? void 0 : (_val$tripRecord6 = val.tripRecord) === null || _val$tripRecord6 === void 0 ? void 0 : (_val$tripRecord6$port = _val$tripRecord6.portLoading) === null || _val$tripRecord6$port === void 0 ? void 0 : _val$tripRecord6$port.portName) || '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord7 = val.tripRecord) !== null && _val$tripRecord7 !== void 0 && _val$tripRecord7.polBlDate ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord8 = val.tripRecord) === null || _val$tripRecord8 === void 0 ? void 0 : _val$tripRecord8.polBlDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord9 = val.tripRecord) !== null && _val$tripRecord9 !== void 0 && _val$tripRecord9.polNor ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord10 = val.tripRecord) === null || _val$tripRecord10 === void 0 ? void 0 : _val$tripRecord10.polNor, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord11 = val.tripRecord) !== null && _val$tripRecord11 !== void 0 && _val$tripRecord11.polNoa ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord12 = val.tripRecord) === null || _val$tripRecord12 === void 0 ? void 0 : _val$tripRecord12.polNoa, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord13 = val.tripRecord) !== null && _val$tripRecord13 !== void 0 && _val$tripRecord13.polAnchorUp ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord14 = val.tripRecord) === null || _val$tripRecord14 === void 0 ? void 0 : _val$tripRecord14.polAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord15 = val.tripRecord) !== null && _val$tripRecord15 !== void 0 && _val$tripRecord15.polBerthing ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord16 = val.tripRecord) === null || _val$tripRecord16 === void 0 ? void 0 : _val$tripRecord16.polBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord17 = val.tripRecord) !== null && _val$tripRecord17 !== void 0 && _val$tripRecord17.polCommenced ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord18 = val.tripRecord) === null || _val$tripRecord18 === void 0 ? void 0 : _val$tripRecord18.polCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord19 = val.tripRecord) !== null && _val$tripRecord19 !== void 0 && _val$tripRecord19.polCompleted ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord20 = val.tripRecord) === null || _val$tripRecord20 === void 0 ? void 0 : _val$tripRecord20.polCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(" " + _vm._s((_Number$toLocaleStrin = (_Number3 = Number(val === null || val === void 0 ? void 0 : (_val$tripRecord21 = val.tripRecord) === null || _val$tripRecord21 === void 0 ? void 0 : _val$tripRecord21.polDraughtSurvey)) === null || _Number3 === void 0 ? void 0 : _Number3.toLocaleString()) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : 0) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord22 = val.tripRecord) !== null && _val$tripRecord22 !== void 0 && _val$tripRecord22.polCastIn ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord23 = val.tripRecord) === null || _val$tripRecord23 === void 0 ? void 0 : _val$tripRecord23.polCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord24 = val.tripRecord) !== null && _val$tripRecord24 !== void 0 && _val$tripRecord24.polCastOut ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord25 = val.tripRecord) === null || _val$tripRecord25 === void 0 ? void 0 : _val$tripRecord25.polCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord26 = val.tripRecord) !== null && _val$tripRecord26 !== void 0 && _val$tripRecord26.polLhv ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord27 = val.tripRecord) === null || _val$tripRecord27 === void 0 ? void 0 : _val$tripRecord27.polLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord28 = val.tripRecord) !== null && _val$tripRecord28 !== void 0 && _val$tripRecord28.polDocOnBoard ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord29 = val.tripRecord) === null || _val$tripRecord29 === void 0 ? void 0 : _val$tripRecord29.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord30 = val.tripRecord) !== null && _val$tripRecord30 !== void 0 && _val$tripRecord30.polDeparture ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord31 = val.tripRecord) === null || _val$tripRecord31 === void 0 ? void 0 : _val$tripRecord31.polDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center",
      staticStyle: {
        "max-width": "250px"
      }
    }, [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : (_val$tripRecord32 = val.tripRecord) === null || _val$tripRecord32 === void 0 ? void 0 : _val$tripRecord32.polRemark) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s((val === null || val === void 0 ? void 0 : (_val$tripRecord33 = val.tripRecord) === null || _val$tripRecord33 === void 0 ? void 0 : _val$tripRecord33.agentPod) || '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s((val === null || val === void 0 ? void 0 : (_val$tripRecord34 = val.tripRecord) === null || _val$tripRecord34 === void 0 ? void 0 : (_val$tripRecord34$por = _val$tripRecord34.portDischarge) === null || _val$tripRecord34$por === void 0 ? void 0 : _val$tripRecord34$por.portName) || '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord35 = val.tripRecord) !== null && _val$tripRecord35 !== void 0 && _val$tripRecord35.podArrivalTime ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord36 = val.tripRecord) === null || _val$tripRecord36 === void 0 ? void 0 : _val$tripRecord36.podArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord37 = val.tripRecord) !== null && _val$tripRecord37 !== void 0 && _val$tripRecord37.podNor ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord38 = val.tripRecord) === null || _val$tripRecord38 === void 0 ? void 0 : _val$tripRecord38.podNor, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord39 = val.tripRecord) !== null && _val$tripRecord39 !== void 0 && _val$tripRecord39.podNoa ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord40 = val.tripRecord) === null || _val$tripRecord40 === void 0 ? void 0 : _val$tripRecord40.podNoa, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord41 = val.tripRecord) !== null && _val$tripRecord41 !== void 0 && _val$tripRecord41.podAnchorUp ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord42 = val.tripRecord) === null || _val$tripRecord42 === void 0 ? void 0 : _val$tripRecord42.podAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord43 = val.tripRecord) !== null && _val$tripRecord43 !== void 0 && _val$tripRecord43.podBerthing ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord44 = val.tripRecord) === null || _val$tripRecord44 === void 0 ? void 0 : _val$tripRecord44.podBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord45 = val.tripRecord) !== null && _val$tripRecord45 !== void 0 && _val$tripRecord45.podCommenced ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord46 = val.tripRecord) === null || _val$tripRecord46 === void 0 ? void 0 : _val$tripRecord46.podCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord47 = val.tripRecord) !== null && _val$tripRecord47 !== void 0 && _val$tripRecord47.podCompleted ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord48 = val.tripRecord) === null || _val$tripRecord48 === void 0 ? void 0 : _val$tripRecord48.podCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(" " + _vm._s((_Number$toLocaleStrin2 = Number(val === null || val === void 0 ? void 0 : (_val$tripRecord49 = val.tripRecord) === null || _val$tripRecord49 === void 0 ? void 0 : _val$tripRecord49.podDraughtSurvey).toLocaleString()) !== null && _Number$toLocaleStrin2 !== void 0 ? _Number$toLocaleStrin2 : 0) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord50 = val.tripRecord) !== null && _val$tripRecord50 !== void 0 && _val$tripRecord50.podCastIn ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord51 = val.tripRecord) === null || _val$tripRecord51 === void 0 ? void 0 : _val$tripRecord51.podCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord52 = val.tripRecord) !== null && _val$tripRecord52 !== void 0 && _val$tripRecord52.podCastOut ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord53 = val.tripRecord) === null || _val$tripRecord53 === void 0 ? void 0 : _val$tripRecord53.podCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && (_val$tripRecord54 = val.tripRecord) !== null && _val$tripRecord54 !== void 0 && _val$tripRecord54.podDeparture ? _vm.moment(val === null || val === void 0 ? void 0 : (_val$tripRecord55 = val.tripRecord) === null || _val$tripRecord55 === void 0 ? void 0 : _val$tripRecord55.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate text-center",
      staticStyle: {
        "max-width": "250px"
      }
    }, [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : (_val$tripRecord56 = val.tripRecord) === null || _val$tripRecord56 === void 0 ? void 0 : _val$tripRecord56.polRemark) + " ")])]);
  }), 0) : _vm._e()])]), _vm.trips_loading ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center w-100 my-2 mb-4"
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Loading trips...")])], 1) : _vm._e(), !_vm.trips_loading && ((_vm$listTrips2 = _vm.listTrips) === null || _vm$listTrips2 === void 0 ? void 0 : _vm$listTrips2.length) <= 0 ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center w-100 my-2 mb-4"
  }, [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v(" No data found. Select other plan. ")])]) : _vm._e()])], 1)], 1)], 1)], 1), _c('b-col', {
    staticClass: "mb-4 mt-0",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('b-button', {
    staticClass: "w-50 mr-2",
    attrs: {
      "variant": "outline-primary",
      "type": "button"
    },
    on: {
      "click": _vm.closeSlideFormRealShipment
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "variant": "primary",
      "type": "submit"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_vm._v(" Submit ")])], 1)])], 1) : _c('div', {
    staticClass: "alert alert-info m-4"
  }, [_vm._v("Loading...")]), _c('b-modal', {
    ref: "descriptionModal",
    attrs: {
      "id": "description-modal",
      "title": "Description",
      "ok-only": "",
      "ok-title": "Close"
    }
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('p', {
    staticClass: "text-wrap"
  }, [_vm._v(_vm._s(_vm.modalContent))])])]), _c('b-modal', {
    ref: "remarksModal",
    attrs: {
      "id": "remarks-modal",
      "title": "Remarks",
      "ok-only": "",
      "ok-title": "Close"
    }
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('p', {
    staticClass: "text-wrap"
  }, [_vm._v(_vm._s(_vm.modalContent))])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }